module.exports = __webpack_public_path__ + "static/media/20ECE12.cfe247c8.jpg";